import { useUnit } from 'effector-react';
import { $global } from 'models/store-global';
import styled from 'styled-components';

import { Frame, Link, RowWrapper } from 'components/StyledTemplates/StyledTemplates';
import { Header } from 'components/pages/Dashboard/common/DashboardPageStyles';

import useResources from 'hooks/useResources';

import connect from 'assets/OriginLogoSmall.png';
import add from 'assets/icons/add.svg';

const YourResources = () => {
    const { t } = useResources();

    const isAdvisorLinked = useUnit($global.map((state) => (state?.community?.advisorParticipantIds || []).length > 0));

    return (
        <>
            <Header extra="margin-top: 20px;">{t(`newDashboardPage.yourResources.header`)}</Header>
            <Link absolute={true} target="_blank" to="https://meetings.hubspot.com/rudyw/supportgroup">
                <ResourceBlock>
                    <ResourceImage>
                        <img src={connect} alt="connect" style={{ width: '40px' }} />
                    </ResourceImage>
                    <ResourceBody>
                        <ResourceHeader>{t('newDashboardPage.yourResources.connect')}</ResourceHeader>
                        <ResourceDescription>
                            {t('newDashboardPage.yourResources.connectDescription')}
                        </ResourceDescription>
                    </ResourceBody>
                </ResourceBlock>
            </Link>
            {!isAdvisorLinked && (
                <Link to="/community/observers">
                    <ResourceBlock>
                        <ResourceImage>
                            <img src={add} alt="add" />
                        </ResourceImage>
                        <ResourceBody>
                            <ResourceHeader>{t('newDashboardPage.yourResources.addAdvisor')}</ResourceHeader>
                            <ResourceDescription>
                                {t('newDashboardPage.yourResources.addAdvisorDescription')}
                            </ResourceDescription>
                        </ResourceBody>
                    </ResourceBlock>
                </Link>
            )}
        </>
    );
};

const ResourceBlock = styled(Frame)`
    border: 1px solid #dfdfdf;
    border-radius: 8px;
    padding: 5px 30px;
    margin-bottom: 14px;
    flex-direction: row;
    cursor: pointer;
    min-height: 90px;
`;

const ResourceImage = styled(Frame)`
    width: 70px;
    align-items: flex-start;
`;

const ResourceBody = styled(Frame)`
    width: 100%;
`;

const ResourceHeader = styled(RowWrapper)`
    /* font-family: 'Marcellus';*/
    font-style: normal;
    font-weight: 400;
    font-size: 20px;
    line-height: 25px;
    padding-bottom: 4px;
    color: #201f22;
`;

const ResourceDescription = styled(RowWrapper)`
    font-weight: 400;
    font-size: 16px;
    line-height: 19px;
    color: #6c757d;
`;

export default YourResources;
